import { generateMarkup } from '@disco/content-editor/default'
import { getDefaultCampaignFooter } from '@disco/state-management/selectors/campaigns'
import { getBusinessSettings } from '@disco/state-management/selectors/user'

import React, { useMemo } from 'react'
import ClipboardButton from 'react-clipboard.js'
import { useSelector } from 'hooks/use-redux'
import type { BusinessData } from 'types/business'
import type {
  Campaign,
  CampaignData,
  CampaignFooter,
} from 'types/content-editor'
import styles from './index.module.css'

type Props = {
  campaignData: CampaignData
  campaign: Campaign
}

const ContentEditorDebugButton = (props: Props): React.ReactElement<'div'> => {
  const businessSettings = useSelector(getBusinessSettings) as BusinessData
  const footer: CampaignFooter | null | undefined = useSelector(
    getDefaultCampaignFooter,
  )
  const [mjml, text] = useMemo(
    () =>
      generateMarkup(
        props.campaign,
        props.campaignData,
        businessSettings,
        footer,
      ),
    [props.campaign, props.campaignData, businessSettings, footer],
  )
  return (
    <div className={styles.contentEditorDebugButton}>
      staff only:
      <ClipboardButton data-clipboard-text={mjml}>copy mjml</ClipboardButton>
      <ClipboardButton data-clipboard-text={text}>copy text</ClipboardButton>
    </div>
  )
}

export default ContentEditorDebugButton
